// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "2d65f155258778b012c55fb3132d180209838801/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};